import {
  ROOT,
  GET_POLICY_PAYMENT,
  UPDATE_POLICY_PAYMENT,
  CREATE_POLICY_PAYMENT,
  DELETE_POLICY_PAYMENT
} from "@/_helpers/constant.js";
import { BehaviorSubject } from "rxjs";
import { requestOptions, handleResponse } from "@/_helpers";

function get(params) {
  return fetch(
    ROOT +
      GET_POLICY_PAYMENT +
      `?limit=${params.limit}&offset=${params.offset}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function update(data) {
  return fetch(ROOT + UPDATE_POLICY_PAYMENT, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function insert(data) {
  return fetch(ROOT + CREATE_POLICY_PAYMENT, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function remove(id) {
  return fetch(ROOT + DELETE_POLICY_PAYMENT + `/${id}`, requestOptions.get())
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

export const service = {
  get,
  update,
  insert,
  remove
};
